document.addEventListener('DOMContentLoaded', function() {
    // Select the span containing the text "All Collections"
    const collectionSpan = document.querySelector('.has-submenu .text-animation--underline-in-header');

    // Check if the span exists and contains the expected text
    if (collectionSpan && collectionSpan.textContent.trim() === 'All Collections') {
      // Select the anchor tag
      const menuLink = collectionSpan.closest('a.menu-link');
      // Set the href attribute to the desired URL
      if (menuLink) {
        menuLink.href = 'https://indiangrinders.com/collections/';
      }
    }
  });

document.addEventListener("DOMContentLoaded", function () {
    // Monitor URL changes to prevent unwanted redirects
    const originalUrl = window.location.href;

    // Observe any navigation or redirection attempts
    const preventRedirect = setInterval(() => {
        if (window.location.href !== originalUrl) {
            console.log("Redirect intercepted:", window.location.href);
            // Stop the redirection
            history.pushState(null, null, originalUrl);
            alert("Unexpected redirect prevented.");
        }
    }, 100);

    // Optional: Add a timeout to stop the observer after a certain time
    setTimeout(() => clearInterval(preventRedirect), 2); // Stop after 10 seconds
});



 

  




